import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'redux/store';
import TcMapSearchResult from '../actions/TcMapSearchResult';
import TcSearchMap from '../actions/TcSearchMap';
import MapViewSearchLoading from '../actions/TcViewSearchLoading';
import TcMapLoading from './TcMapLoading';
import TcMapRightToolsWrapper from './TcMapRightToolsWrapper';
import TcMapViewerWrapper from './TcMapViewWrapper';
import TcWrapperSearchMap from './TcWrapperSearchMap';

interface Props {
  setSelectedLocation?: (_latlng: { lat: number; lng: number }) => void;
  selectedLocation?: { lat: number; lng: number };
}

const TcMapView: FC<Props> = ({ selectedLocation, setSelectedLocation }) => {
  //states
  const { loading, viewSearchLoading } = useSelector((state: RootState) => state.map);
  const { fullScreen } = useSelector((state: RootState) => state.setting);

  //hooks
  const { push } = useHistory();

  const handleUrl = (zoomLevel: number, center: Record<'lat' | 'lng', any>) => {
    const query = new URLSearchParams(window.location.search);
    // replace z and x and y in currect query and convert it to string
    query.set('z', zoomLevel + '');
    query.set('x', center.lng);
    query.set('y', center.lat);
    const stringQuery = query.toString();

    push({
      search: stringQuery,
    });
  };
  return (
    <>
      <div className={fullScreen ? 'fixed top-0 left-0 w-full h-full' : 'relative'}>
        <TcMapViewerWrapper handleUrl={handleUrl} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} />

        {loading && <TcMapLoading />}
        {viewSearchLoading && <MapViewSearchLoading />}

        <TcWrapperSearchMap>
          <TcSearchMap />
        </TcWrapperSearchMap>

        <TcMapRightToolsWrapper>
          <TcMapSearchResult />
        </TcMapRightToolsWrapper>
      </div>
      {/* <MapSearchCityPolygon /> */}
    </>
  );
};

export default TcMapView;
